// not supported for images, uploaded with V2 api (see S3UploadAPI)
export function setS3ImageOptions(imgUrl: string, width: number, height?: number, mode: 'fill' | 'fit' = 'fill') {
  return `${imgUrl}?w=${width}&h=${height ?? width}&m=${mode}`;
}
